function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_68356",
  "data-name": "Group 68356"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52415",
  "data-name": "Path 52415",
  d: "M18.532,9H5.468A1.027,1.027,0,0,1,4.44,7.973V7.027A1.027,1.027,0,0,1,5.468,6H18.533A1.027,1.027,0,0,1,19.56,7.027v.945A1.028,1.028,0,0,1,18.532,9Z",
  fill: "none",
  stroke: "#ff6060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52416",
  "data-name": "Path 52416",
  d: "M18,9l-.847,10.166A2,2,0,0,1,15.16,21H8.84a2,2,0,0,1-1.993-1.834L6,9",
  fill: "none",
  stroke: "#ff6060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52417",
  "data-name": "Path 52417",
  d: "M8,6,9.224,3.553A1,1,0,0,1,10.118,3h3.764a1,1,0,0,1,.894.553L16,6",
  fill: "none",
  stroke: "#ff6060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52418",
  "data-name": "Path 52418",
  d: "M12,12v6",
  fill: "none",
  stroke: "#ff6060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52419",
  "data-name": "Path 52419",
  d: "M15,12l-.41,6",
  fill: "none",
  stroke: "#ff6060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52420",
  "data-name": "Path 52420",
  d: "M9,12l.41,6",
  fill: "none",
  stroke: "#ff6060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52421",
  "data-name": "Path 52421",
  d: "M0,0H24V24H0Z",
  fill: "none"
});

function SvgTrashDeleteBin3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash-delete-bin.3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDeleteBin3);
export default __webpack_public_path__ + "static/media/trash-delete-bin.3.573c4e04.svg";
export { ForwardRef as ReactComponent };